import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { MessageCircle, AlertCircle } from 'lucide-react';

interface ResponseNodeProps {
  data: {
    label: string;
    isDefault?: boolean;
    option?: {
      display: string;
      question: string;
      topic_key: string;
    };
    default?: {
      response: string;
      commands: Array<Record<string, any>>;
    };
  };
  selected: boolean;
}

export const ResponseNode: React.FC<ResponseNodeProps> = ({ data, selected }) => {
  const isDefault = data.isDefault;
  
  return (
    <div 
      className={`px-3 py-2 ${
        isDefault 
          ? 'bg-gradient-to-r from-red-600 to-red-700 dark:from-red-700 dark:to-red-800' 
          : 'bg-gradient-to-r from-purple-600 to-purple-700 dark:from-purple-700 dark:to-purple-800'
      } text-white rounded-md min-w-[160px] max-w-[250px] shadow-sm transition-all duration-200 hover:shadow-md hover:scale-105 cursor-pointer ${
        selected ? 'ring-2 ring-yellow-400 ring-offset-2 ring-offset-gray-100 dark:ring-offset-gray-800 scale-105' : ''
      }`}
    >
      <Handle 
        type="target" 
        position={Position.Left} 
        className={`w-2.5 h-2.5 ${isDefault ? 'bg-red-400' : 'bg-purple-400'} border-2 border-white dark:border-gray-800`}
      />
      <div className="flex items-center gap-1.5 mb-1">
        {isDefault ? (
          <AlertCircle size={14} className="text-red-200" />
        ) : (
          <MessageCircle size={14} className="text-purple-200" />
        )}
        <span className="text-xs font-medium">
          {isDefault ? 'Default' : 'Response'}
        </span>
      </div>
      <div className="text-xs break-words line-clamp-3 opacity-90">
        {data.label}
      </div>
      <Handle 
        type="source" 
        position={Position.Right} 
        className={`w-2.5 h-2.5 ${isDefault ? 'bg-red-400' : 'bg-purple-400'} border-2 border-white dark:border-gray-800`}
      />
    </div>
  );
};